module.exports = __webpack_public_path__ + "static/media/Winnipeg_Jets.45b0cbef.svg";